/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsUserDashboardParametersResponse } from './RevisdomAPIViewModelsUserDashboardParametersResponse';
import {
    RevisdomAPIViewModelsUserDashboardParametersResponseFromJSON,
    RevisdomAPIViewModelsUserDashboardParametersResponseFromJSONTyped,
    RevisdomAPIViewModelsUserDashboardParametersResponseToJSON,
    RevisdomAPIViewModelsUserDashboardParametersResponseToJSONTyped,
} from './RevisdomAPIViewModelsUserDashboardParametersResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1DashboardParametersResponse
 */
export interface ApiResponse1DashboardParametersResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1DashboardParametersResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1DashboardParametersResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsUserDashboardParametersResponse}
     * @memberof ApiResponse1DashboardParametersResponse
     */
    data?: RevisdomAPIViewModelsUserDashboardParametersResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1DashboardParametersResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1DashboardParametersResponse interface.
 */
export function instanceOfApiResponse1DashboardParametersResponse(value: object): value is ApiResponse1DashboardParametersResponse {
    return true;
}

export function ApiResponse1DashboardParametersResponseFromJSON(json: any): ApiResponse1DashboardParametersResponse {
    return ApiResponse1DashboardParametersResponseFromJSONTyped(json, false);
}

export function ApiResponse1DashboardParametersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1DashboardParametersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsUserDashboardParametersResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1DashboardParametersResponseToJSON(json: any): ApiResponse1DashboardParametersResponse {
    return ApiResponse1DashboardParametersResponseToJSONTyped(json, false);
}

export function ApiResponse1DashboardParametersResponseToJSONTyped(value?: ApiResponse1DashboardParametersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsUserDashboardParametersResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

